import { TDateISO } from "types/date";

export const MINUTE_IN_MILLISECONDS = 60 * 1000;
export const HOUR_IN_MILLISECONDS = 60 * MINUTE_IN_MILLISECONDS;

import {
  MILLISECONDS_PER_SECOND,
  SECONDS_PER_MINUTE,
  MINUTES_PER_HOUR,
} from "./constants";

export function getElapsedTimeInMilliseconds(timestamp: TDateISO): number {
  const now: Date = new Date();
  const then: Date = new Date(timestamp);

  return Math.abs(now.getTime() - then.getTime());
}

export function getStringifiedElapsedTime(timestamp: TDateISO): string {
  const dateISORegex: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

  if (!timestamp.match(dateISORegex) || Number.isNaN(Date.parse(timestamp))) {
    console.error(
      `Error in getStringifiedElapsedTime: timestamp "${timestamp}" is not a valid format.`,
    );

    return null;
  }

  const millisecondsElapsed: number = getElapsedTimeInMilliseconds(timestamp);
  const seconds = millisecondsElapsed / MILLISECONDS_PER_SECOND;
  const minutes = seconds / SECONDS_PER_MINUTE;
  const hours = minutes / MINUTES_PER_HOUR;

  if (hours >= 1) {
    const roundedHours = Math.round(hours);

    return `${roundedHours} ${roundedHours > 1 ? "hrs" : "hr"}`;
  }

  if (minutes >= 1) {
    const roundedMinutes = Math.round(minutes);

    return `${roundedMinutes} ${roundedMinutes > 1 ? "mins" : "min"}`;
  }

  return `${Math.round(seconds)} secs`;
}
